import { ColumnSettings, ColumnTypes } from '@app/storybook/components/table/table.component';

export enum planStatus {
  active = 'active',
}

export interface tab {
  active: boolean;
  value: string;
  label: string;
  displayed: (any) => boolean;
}

export const tabs: tab[] = [
  {
    label: 'Overview',
    value: 'overview',
    active: true,
    displayed: (plan) => {
      return (plan?.active == 1 && !plan?.planTemplate?.isDummy) || !!plan?.splitBillingStatus;
    },
  },
  {
    label: 'Billing history',
    value: 'history',
    active: false,
    displayed: (plan) => {
      return plan ? true : false;
    },
  },
  {
    label: 'Plans',
    value: 'plans',
    active: false,
    displayed: (plan) => true,
  },
];

export const historyColumns: ColumnSettings[] = [
  {
    type: ColumnTypes.CHECKBOX,
    prop: 'checkbox',
    hideColumnName: true,
    sortable: false,
    width: 35,
    minWidth: 35,
    maxWidth: 35,
  },
  { prop: 'eventType', name: 'Item Type', type: ColumnTypes.TEXT, sortable: true, width: 50 },
  { prop: 'eventDate', name: 'Date', type: ColumnTypes.DATE, sortable: true, width: 40 },
  {
    prop: 'referenceNumber',
    type: ColumnTypes.TEXT,
    name: 'Reference No.',
    sortable: true,
    searchable: true,
    width: 30,
  },
  { prop: 'paymentStatus', name: 'Payment Status', type: ColumnTypes.TEXT, sortable: true, width: 20 },
  { prop: 'amount', name: 'Amount', type: ColumnTypes.TEXT, sortable: true, width: 80 },
];
